import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const wrapper: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'stretch',
  flexDirection: 'row',
  flexGrow: 1,
}

export const textContainer: React.CSSProperties = {
  flexGrow: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  overflow: 'hidden',
  marginRight: toPx(sharedStyles.Spacings.NORMAL),
}

export const textStyle: React.CSSProperties = {
  ...sharedStyles.subheading,
  ...sharedStyles.textBlack,
  ...sharedStyles.textEllipsis,
  flexGrow: 1,
  textAlign: 'left',
}

export const infoWrapper: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  marginRight: toPx(sharedStyles.NEXT_STEP_DOT_SIZE / -2),
}

export const iconSpriteStyle: React.CSSProperties = {
  width: toPx(sharedStyles.IconSizes.MEDIUM),
  height: toPx(sharedStyles.IconSizes.MEDIUM),
  flexShrink: 0,
  marginLeft: toPx(sharedStyles.Spacings.SMALL),
}
